var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFt4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#DB0035",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7165 15.4286C15.2945 15.4286 16.5737 14.1495 16.5737 12.5715C16.5737 10.9935 15.2945 9.71436 13.7165 9.71436C12.1386 9.71436 10.8594 10.9935 10.8594 12.5715C10.8594 14.1495 12.1386 15.4286 13.7165 15.4286Z",
    fill: "#DB0035"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57227 23.4285H13.7151H18.858V22.809C18.8489 21.9378 18.6191 21.0833 18.1902 20.325C17.7613 19.5668 17.1472 18.9297 16.4053 18.4731C15.6634 18.0165 14.8179 17.7555 13.9477 17.7143C13.8701 17.7106 13.7926 17.7087 13.7151 17.7085C13.6377 17.7087 13.5601 17.7106 13.4825 17.7143C12.6124 17.7555 11.7668 18.0165 11.0249 18.4731C10.283 18.9297 9.66892 19.5668 9.24 20.325C8.8111 21.0833 8.58136 21.9378 8.57227 22.809V23.4285Z",
    fill: "#DB0035"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7165 15.4286C15.2945 15.4286 16.5737 14.1495 16.5737 12.5715C16.5737 10.9935 15.2945 9.71436 13.7165 9.71436C12.1386 9.71436 10.8594 10.9935 10.8594 12.5715C10.8594 14.1495 12.1386 15.4286 13.7165 15.4286Z",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57227 23.4285H13.7151H18.858V22.809C18.8489 21.9378 18.6191 21.0833 18.1902 20.325C17.7613 19.5668 17.1472 18.9297 16.4053 18.4731C15.6634 18.0165 14.8179 17.7555 13.9477 17.7143C13.8701 17.7106 13.7926 17.7087 13.7151 17.7085C13.6377 17.7087 13.5601 17.7106 13.4825 17.7143C12.6124 17.7555 11.7668 18.0165 11.0249 18.4731C10.283 18.9297 9.66892 19.5668 9.24 20.325C8.8111 21.0833 8.58136 21.9378 8.57227 22.809V23.4285Z",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2852 15.4286C19.8631 15.4286 21.1423 14.1495 21.1423 12.5715C21.1423 10.9935 19.8631 9.71436 18.2852 9.71436",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.144 23.4286H23.4297V22.809C23.4205 21.9379 23.1908 21.0833 22.7619 20.325C22.333 19.5668 21.7189 18.9297 20.977 18.4731C20.4975 18.178 19.9745 17.9645 19.4297 17.8394",
    stroke: "#DB0035",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFt4);
export default __webpack_public_path__ + "static/media/ft_4.0e43561a41591c2858e118bca95b8e0d.svg";
export { ForwardRef as ReactComponent };